export enum EngagementEvent {
  ENGAGEMENT_OPENED = 'client_portal_engagement_opened',
  ENGAGEMENT_LIST_OPENED = 'client_portal_engagement_list_opened',
}

export interface EngagementOpenedEvent {
  engagementId: number;
}
